module.exports = __webpack_public_path__ + "static/media/add-user.5fc46b14.svg";